import React from "react";
import domtoimage from "dom-to-image";
import { connect } from "react-redux";
import ImageBrand from "./ImageBrand";
import LogoBrand from "./LogoBrand";
import bannerGeneratorAction from "../../../../store/actions/bannerGenerator";
import bannerGeneratorHelper from "../banner-generator/helper";
import helpersNumbers from "../../../../helpers/numbers";
import { useState } from "react";
import { Editor } from "@tinymce/tinymce-react";

function BannerDetails({
  banner,
  title,
  description,
  titleButton,
  colorButton,
  colorTextButton,
  backgroundColorDetailsArea,
  setTitle,
  setDescription,
  setTitleButton,
  setColorTextButton,
  setColorButton,
  setBackgroundColorDetailsArea,
  setBorderRadiusButton,
}) {
  const apiKey = "n0pnn5k9s0m0dsdttkjemajjkwr2ud59f1m3kvan1f8skwc5";
  const pluginsTinyMCEEditor = [
    "advlist autolink lists link image charmap print preview anchor",
    "searchreplace visualblocks code fullscreen",
    "insertdatetime media table paste code wordcount",
  ];
  const toolBarTinyMCEEditor = [
    "undo redo | formatselect | " +
      "bold italic backcolor | alignleft aligncenter " +
      "alignright alignjustify | bullist numlist outdent indent | " +
      "removeformat ",
  ];
  const bodyStyleTinyMCEEditor = "body {direction: rtl}";
  const [buttonTypeSelect, setButtonTypeSelect] = useState(2);
  const removeBorderPreviewBanner = () => {
    const previewBanner = document.querySelector("#preview-banner");
    previewBanner.classList.remove("border");
    previewBanner.classList.remove("border-1");
  };

  const addBorderPreviewBanner = () => {
    const previewBanner = document.querySelector("#preview-banner");
    previewBanner.classList.add("border");
    previewBanner.classList.add("border-1");
  };

  const downloadBanner = () => {
    const previewBanner = document.getElementById("preview-banner");
    removeBorderPreviewBanner();
    domtoimage
      .toJpeg(previewBanner)
      .then(function (dataUrl) {
        const link = document.createElement("a");
        link.download = `hilite-banner-generator-${banner.size.width}-${banner.size.height}.jpeg`;
        link.href = dataUrl;
        link.click();
        addBorderPreviewBanner();
      })
      .catch(function (error) {
        alert("دانلود انجام نشد");
      });
  };

  return (
    <div>
      <div className="pb-3">
        <div className="text-right">
          <label>عنوان تبلیغ</label>
        </div>
        <Editor
          apiKey={apiKey}
          value={title}
          onEditorChange={(content) => {
            setTitle({
              title: content,
            });
          }}
          init={{
            height: 200,
            menubar: false,
            plugins: pluginsTinyMCEEditor,
            toolbar: toolBarTinyMCEEditor,
            content_style: bodyStyleTinyMCEEditor,
          }}
        />
      </div>
      <div className="pb-3">
        <div className="text-right">
          <label>توضیحات تبلیغ</label>
        </div>
        <Editor
          apiKey={apiKey}
          value={description}
          onEditorChange={(content) => {
            setDescription({
              description: content,
            });
          }}
          init={{
            height: 300,
            menubar: false,
            plugins: pluginsTinyMCEEditor,
            toolbar: toolBarTinyMCEEditor,
            content_style: bodyStyleTinyMCEEditor,
          }}
        />
      </div>
      <div className="d-flex flex-column flex-lg-row pb-3 inputs-button-details">
        <div className="d-flex flex-column title-button-input">
          <label className="d-flex text-right">عنوان دکمه</label>
          <input
            className="form-control "
            onChange={(e) => {
              setTitleButton({
                titleButton: e.target.value,
              });
            }}
            defaultValue={titleButton}
          />
        </div>
        <div className="d-flex flex-column flex-lg-row justify-content-between pr-lg-4 flex-grow-1 pt-3 pt-lg-0">
          <div className="d-flex flex-column">
            <label>شکل دکمه </label>
            <div
              className="border border-1 p-1 w-lg-fit-content d-flex justify-content-around "
              style={{ borderRadius: ".25rem" }}
            >
              <span>
                <span
                  className={`btn ${
                    buttonTypeSelect == 1
                      ? "btn-outline-success "
                      : "btn-success "
                  }`}
                  style={{ borderRadius: "0px" }}
                  onClick={() => {
                    setBorderRadiusButton({
                      borderRadiusButton: 0,
                    });
                    setButtonTypeSelect(1);
                  }}
                >
                  نوک تیز
                </span>
              </span>
              <span className="px-2">
                <span
                  className={`btn ${
                    buttonTypeSelect == 2
                      ? "btn-outline-success "
                      : "btn-success "
                  }`}
                  style={{ borderRadius: "10px" }}
                  onClick={() => {
                    setBorderRadiusButton({
                      borderRadiusButton: 10,
                    });
                    setButtonTypeSelect(2);
                  }}
                >
                  پیش فرض
                </span>
              </span>
              <span>
                <span
                  className={`btn ${
                    buttonTypeSelect == 3
                      ? "btn-outline-success "
                      : "btn-success "
                  }`}
                  style={{ borderRadius: "20px" }}
                  onClick={() => {
                    setBorderRadiusButton({
                      borderRadiusButton: 20,
                    });
                    setButtonTypeSelect(3);
                  }}
                >
                  نوک گرد
                </span>
              </span>
            </div>
          </div>

          <div className="d-flex flex-column justify-content-between align-items-start align-lg-items-end pt-3 pt-lg-0">
            <div className="w-100">
              <label className="d-flex text-right"> رنگ پس زمنیه دکمه </label>
              <input
                className="form-control flex-lg-grow-1 w-100"
                type="color"
                style={{ width: "80px" }}
                defaultValue={colorButton}
                onChange={(e) => {
                  setColorButton({
                    colorButton: e.target.value,
                  });
                }}
              />
            </div>
            <div className="w-100">
              <label className="d-flex text-right"> رنگ متن دکمه </label>
              <input
                className="form-control flex-lg-grow-1 w-100"
                type="color"
                style={{ width: "80px" }}
                defaultValue={colorTextButton}
                onChange={(e) => {
                  setColorTextButton({
                    colorTextButton: e.target.value,
                  });
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex flex-column flex-lg-row  pb-5 inputs-logo-details">
        <div>
          <label className="d-flex text-right"> لوگو برند</label>
          <LogoBrand />
        </div>
        <div className="d-flex flex-column flex-grow-1 pr-lg-4 pt-3 pt-lg-0">
          <label className="d-flex text-right"> رنگ پس زمینه </label>
          <input
            className="form-control flex-lg-grow-1 w-100"
            type="color"
            defaultValue={backgroundColorDetailsArea}
            onChange={(e) => {
              setBackgroundColorDetailsArea({
                backgroundColorDetailsArea: e.target.value,
              });
            }}
          />
        </div>
      </div>

      <div className="d-flex d-flex flex-column flex-lg-row justify-content-between pb-3">
        <div className="ps-2 d-flex justify-content-center text-center">
          <ImageBrand banner={banner} />
        </div>
        <div className="ps-2 d-flex justify-content-center text-center pt-2 pt-lg-0">
          <div
            className="d-flex flex-column justify-content-around box-upload-banner hover bg-hilite p-2 border border-1 border-dark"
            onClick={downloadBanner}
          >
            <span>
              <span>تصویر بنر </span>
              <span className="px-2">
                {helpersNumbers.toPersianNum(banner.size.height)}
                <span className="px-2">*</span>
                {helpersNumbers.toPersianNum(banner.size.width)}
              </span>
              <span> را دانلود کنید</span>
            </span>
            <span className="text-center">
              <img src="/assets/img/download-banner-generator.svg" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    setTitle: (action) => {
      dispatch({
        type: bannerGeneratorAction.SET_TITLE,
        payload: action,
      });
    },
    setDescription: (action) => {
      dispatch({
        type: bannerGeneratorAction.SET_DESCRIPTION,
        payload: action,
      });
    },
    setColorButton: (action) => {
      dispatch({
        type: bannerGeneratorAction.SET_COLOR_BUTTON,
        payload: action,
      });
    },
    setTitleButton: (action) => {
      dispatch({
        type: bannerGeneratorAction.SET_TITLE_BUTTON,
        payload: action,
      });
    },
    setColorTextButton: (action) => {
      dispatch({
        type: bannerGeneratorAction.SET_COLOR_TEXT_BUTTON,
        payload: action,
      });
    },
    setImageBanner: (action) => {
      dispatch({
        type: bannerGeneratorAction.SET_BANNER,
        payload: action,
      });
    },
    setBackgroundColorDetailsArea: (action) => {
      dispatch({
        type: bannerGeneratorAction.SET_BACKGROUND_COLOR_DETAILS_AREA,
        payload: action,
      });
    },
    setBorderRadiusButton: (action) => {
      dispatch({
        type: bannerGeneratorAction.SET_BORDER_RADIUS_BUTTON,
        payload: action,
      });
    },
  };
};

export default connect(
  bannerGeneratorHelper.getDetailsBanner,
  mapDispatchToProps
)(BannerDetails);
